import React from "react";

import styles from "./PrivacyPolicy.module.css";
const WebsiteTerms = () => {
  return (
     <div className={styles.privacyContainer}>
      <h1 style={{ textAlign: "center" }}>Terms of Use</h1>

      <h4>Introduction</h4>
      <p>
        These Terms of Use govern your access to and use of the JTDCL Hotel
        Booking App and web portal provided by{" "}
        <strong>Jharkhand Tourism Development Corporation Ltd. (JTDCL)</strong>. By
        using our services, you agree to be bound by these terms.
      </p>

      <h4>Use of the Web Portal & App</h4>
      <p>
        This platform is for booking hotels and tourism services offered by
        JTDCL. You must be at least 18 years old to use the portal or app. You
        agree to provide accurate and complete information during booking.
      </p>

      <h4>Booking and Payment</h4>
      <p>
        All bookings are subject to availability. Payments are processed
        securely through authorized gateways. Booking confirmations are issued
        only upon successful payment.
      </p>

      <h4>Cancellation & Refund</h4>
      <p>
        Refund and cancellation policies are governed by JTDCL guidelines and
        will be shown during the booking process.
      </p>

      <h4>Prohibited Activities</h4>
      <p>
        You must not use the portal or app for illegal activities, attempt
        unauthorized access, or misrepresent your identity.
      </p>

      <h4>Intellectual Property</h4>
      <p>
        All content, logos, and data on the platform are the property of JTDCL
        and are protected by applicable intellectual property laws.
      </p>

      <h4>Limitation of Liability</h4>
      <p>
        JTDCL will not be liable for booking errors made by users, payment
        failures caused by third-party gateways, or temporary service
        disruptions.
      </p>

      <h4>Modifications</h4>
      <p>
        JTDCL reserves the right to update or modify these Terms of Use at any
        time. Continued use of the platform after updates constitutes acceptance
        of the revised terms.
      </p>

      <h4>Contact Us</h4>
      <p>
        For queries or concerns, please contact: <br />
        Jharkhand Tourism Development Corporation Ltd. <br />
        Email: jtdcltd@gmail.com <br />
        Phone: +91 9102403884
      </p>
    </div>
  
  );
};

export default WebsiteTerms;